<script>
    import {APP_VERSION} from "./lib/constants";
    import Route, {router} from "./lib/Router/Router.svelte";
    import R from "./lib/requests";
    import app from './stores/app';
    import user from "./stores/user";
    import AppHeader from "./components/AppHeader.svelte";
    import Alert from "./components/Alert.svelte";
    import Notifier from './components/Notifier.svelte';
    import PageLoader from "./components/PageLoader.svelte";
    import PopupLoader from "./components/PopupLoader.svelte";
    import Orders from "./orders/Orders.svelte";
    import PageNotFound from "./components/pages/PageNotFound.svelte";

    let appInitialized = false;
    let appError = false;

    const appInitialize = () => {
        const onSuccess = result => {
            $user.id = result.client.id;
            $user.name = result.client.name;
            $user.company = result.client.company;
            $app.app_url = result.app_url;

            if (APP_VERSION !== result.app_version) {
                alert("Η έκδοση της εφαρμογής που χρησιμοποιείται είναι πεπερασμένη!\nΚαθαρίστε την προσωρινή μνήμη του browser σας και ανανεώστε αυτή την σελίδα για να χρησιμοποιήσετε την πιο πρόσφατη έκδοση της εφαρμογής.");
            }

            appInitialized = true;
        }

        const onFailure = err => {
            appError = true;
        };

        R.handle(R.app.initialize, [], onSuccess, onFailure);
    }

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && $app.escapeEventHandlers.length) {
            $app.escapeEventHandlers[$app.escapeEventHandlers.length - 1]();
        }
    });

    // Get user cloud key
    let arr = window.location.pathname.split('/');
    if (arr.length > 1) {
        $user.cloud_key = arr[1];
    }

    appInitialize();
</script>


{#if appInitialized}
    <PageLoader/>
    <PopupLoader/>
    <AppHeader/>
    <main>
        <div class="app-main-content">
            <div class="container-fluid">
                <Route match="/">
                    <Route match="{ $user.cloud_key }">
                        <Orders/>
                    </Route>
                </Route>
            </div>
        </div>
    </main>
{/if}
{#if appError}
    <PageNotFound/>
{/if}

<Alert/>
<Notifier/>

<style>
    main {
        width: 100%;
    }

    @media (max-width: 999px) {
        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1000px) and (max-width: 1024px) {
        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }

    @media (min-width: 1025px) {
        main .app-main-content {
            padding: 80px 10px 20px 10px;
        }
    }
</style>